module.exports = " <div class=\"card card-preview\" v-show=enabled> <table class=table> <tbody> <tr v-for=\"item in data\"> <td>{{ item.label }}</td> <td>{{ item.value }}</td> </tr> </tbody> </table> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/grid/Preview.vue
// module id = 498
// module chunks = 1